'use es6';

import SafeStorage from 'SafeStorage';
import Raven from 'raven-js'; // SafeStorage is not as safe as we'd like. Since LocalStorage is only used for
// convenience features, it's perfectly fine for us to catch all exceptions.

export default {
  getItem: (...args) => {
    try {
      return SafeStorage.getItem(...args);
    } catch (e) {
      Raven.captureException(e);
      return undefined;
    }
  },
  setItem: (...args) => {
    try {
      return SafeStorage.setItem(...args);
    } catch (e) {
      Raven.captureException(e);
      return undefined;
    }
  },
  removeItem: (...args) => {
    try {
      return SafeStorage.removeItem(...args);
    } catch (e) {
      Raven.captureException(e);
      return undefined;
    }
  }
};